var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpoonIconBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00271 5.55857C0.754305 4.31102 0.754305 2.34374 2.00271 1.09619L7.33243 6.42225L9.10901 8.1976L11.8459 10.9326C12.326 11.4124 12.326 12.1322 11.8459 12.612C11.3657 13.0918 10.5015 13.0918 10.0693 12.516L8.10068 10.0689C7.62053 9.44515 6.75625 9.25322 5.988 9.54111L2.00271 5.55857Z",
    stroke: "#020202",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10938 4.88671L11.7022 2.29565",
    stroke: "#020202",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05469 7.14177C8.24675 7.09379 8.3908 7.09379 8.58286 7.04581C9.20706 6.99782 9.92729 6.66195 10.6475 5.94221L13.0003 3.59106",
    stroke: "#020202",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78915 8.34131L1.42806 11.0763C0.899894 11.4602 0.851878 12.2279 1.33203 12.6597C1.81219 13.1396 2.53242 13.0436 2.91655 12.5638L5.65343 9.15701",
    stroke: "#020202",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4059 1L8.00508 3.35114C7.28484 4.07088 6.90072 4.79062 6.90072 5.41439C6.90072 5.60632 6.8527 5.75027 6.80469 5.9422",
    stroke: "#020202",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpoonIconBlack);
export default __webpack_public_path__ + "static/media/spoonIconBlack.70987aace893869de598fc06b16f8c71.svg";
export { ForwardRef as ReactComponent };